var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "80vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t")
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c(
                "q-list",
                { attrs: { separator: "", highlight: "" } },
                [
                  _vm._l(_vm.answers, function(answer, index) {
                    return [
                      !answer.justification
                        ? _c(
                            "q-item",
                            { key: index },
                            [
                              _c("q-item-main", {
                                attrs: {
                                  label:
                                    answer.user_full_name +
                                    " - " +
                                    answer.user_email +
                                    " - " +
                                    answer.user_profile,
                                  "label-lines": "1"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "row justify-center" },
                [
                  _c("q-pagination", {
                    attrs: { input: "", min: _vm.minPages, max: _vm.maxPages },
                    on: { input: _vm.fetchData },
                    model: {
                      value: _vm.page,
                      callback: function($$v) {
                        _vm.page = $$v
                      },
                      expression: "page"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }